import { FC, useContext, useEffect } from 'react';
import { AxiosResponse, AxiosError } from 'axios';
import * as Sentry from '@sentry/react';

import { axiosInstance } from 'shared/services/http.service';
import { IResponseObject } from 'shared/interface';
import Notification, { notify } from 'shared/components/notification/notification';
import { AuthContext } from 'store/userDetailStore';

const ErrorHandler: FC = () => {
	const { logout } = useContext(AuthContext);

	useEffect(() => {
		const resInterceptor = axiosInstance.interceptors.response.use(
			(res: AxiosResponse<IResponseObject<any>>) => {
				const data = res.data;
				if (data && data.message) {
					if (data.is_error) {
						notify(data.message, 'error');
						throw new Error(data.message as string);
					} else {
						notify(data.message, 'success');
					}
				}

				return res;
			},
			(error: AxiosError<IResponseObject<any>>) => {
				const res = error.response;
				// check if error is having data
				if (res && res.data && res.status) {
					const status = res.status;
					const responseData = res.data;

					// is http error code is 401, log out of the application
					if (status === 401 && responseData) {
						logout();
						notify(responseData.message, 'error');
					} else if (responseData && responseData.message) {
						// console.log('test error resInterceptor');
						// if error data contains message field, add error notification
						notify(responseData.message, 'error');
					}
					Sentry.captureException(error);
					throw error;
				}
			}
		);
		return () => axiosInstance.interceptors.response.eject(resInterceptor);
	}, [logout]);
	return <Notification />;
};

export default ErrorHandler;
